import React, { useState, useEffect, useRef, useMemo, Fragment } from 'react'
import { useStore } from '@nanostores/react'
import {
    isCartOpen,
    cartData,
    hasCartQuantityError,
} from '@stores/cartStore.js'
import { optionsData } from '@stores/productOptionsStore'
import useWindowDimensions from '@hooks/useWindowDimensions.js'

import qs from 'query-string'
import parse from 'html-react-parser'
import 'balloon-css'
import Cookies from 'js-cookie'

import Lightbox from 'yet-another-react-lightbox'
import Zoom from 'yet-another-react-lightbox/plugins/zoom'
import 'yet-another-react-lightbox/styles.css'
import va from '@vercel/analytics'

import ProductVideo from '@components/ProductVideo/ProductVideo.jsx'
import VideoPlaceholder from '@components/ProductVideo/VideoPlaceholder.jsx'
import Embroidery from '@components/ProductOptions/Embroidery.jsx'
import PDPAccordion from '@components/Accordion/PDPAccordion.jsx'
import ShopMore from '@components/ShopMore/ShopMore.jsx'
import CaretUp from '@components/Icons/CaretUp.jsx'
import CaretDown from '@components/Icons/CaretDown.jsx'
import Price from '@components/Price/Price.jsx'
import SizeGuide from '@components/SizeGuide/SizeGuide.jsx'
import Heart from '@components/Icons/Heart.jsx'
import Asterisk from '@components/Icons/Asterisk.jsx'
import NotAllowed from '@components/Icons/NotAllowed'
import AngleLeft from '@components/Icons/AngleLeft.jsx'
import AngleRight from '@components/Icons/AngleRight.jsx'
import Loader from '@components/Loader/Loader.jsx'
import Flags from './Flags.jsx'
import ProductOffers from './ProductOffers.jsx'
import ProductSchema from '@components/Schema/ProductSchema.jsx'
import StickyAddToCart from './StickyAddToCart.jsx'
import Tag30Off from '@components/SaleRibbon/Tag30Off.jsx'
import OrganicTag from '@icons/OrganicTag.jsx'
import Recommended from '@components/Recommendations/Recommended.jsx'
import Affirm from '@components/Product/Affirm.jsx'
import Countdown from '@components/Countdown/Countdown.jsx'
import NostoRecommendations from '@components/Recommendations/NostoRecommendations.jsx'


import { embroideryData } from '@data/embroidery_data.js'

import { createCart, addToCart, updateCartAttributes } from '@api/shopify.js'
import { chord } from '@api/chord.js'

import { productColors } from '@data/productColors.js'

//

import {
    getUniqueListBy,
    insertUrlParam,
    slugify,
    slugString,
    trimLeadingTrailingSpaces,
    trimLeadingSpaces,
    splitMulti,
    unslugify,
    sizeSortFunc,
    convertToCurrency,
    getCookie,
    groupBy,
    isEmpty,
    getSessionStorageOrDefault,
    endsWithNumber,
    getProducts,
    splitLastOccurrence,
} from '@utils/utils'

// import { all } from 'axios'
import { replaceUrlParam } from '../../utils/utils.js'

const FILES_URL = 'https://cdn.shopify.com/s/files/1/2338/2917/files/'

const BOOST_URL =
    'https://services.mybcapps.com/bc-sf-filter/search?shop=monicaandandyonline.myshopify.com&limit=70&q='

// tag object { tag name : tag message}
const tagObject = {
    Buy2Get20: 'Buy 2 Get 20% Off',
    Buy2Get25: 'Buy 2 Get 25% Off',
    Buy3Get30: 'Buy 3 Get 30% Off',
    UPF50: 'UPF 50',
}

const productTypeArray = [
    'Gift Card',
    'Gift Cards',
    'Specialty SKU',
    'Embroidery Option',
    'Embroidery',
    'Virtual Classes',
    'Classes + Events',
    'Nursery',
    'Cribs',
    'Classes',
    'Strollers',
]

const productTypes40Off = ['Swimwear', 'Sun Hats', 'Swim Coverups']

const registryHtml = `<span class="flex items-center justify-center gap-2"><div class='heart-icon w-[24px] max-w-[24px]'><svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" enableBackground="new 0 0 100 100" version="1.1" viewBox="0 0 100 100" xmlSpace="preserve"><path d="M49.9 91.9L8.1 50.1c-9-9-9-23.6 0-32.6s23.6-9 32.6 0l9.2 9.2 9.2-9.2c9-9 23.6-9 32.6 0s9 23.6 0 32.6L49.9 91.9zM12.6 22c-6.5 6.5-6.5 17.1 0 23.6l37.3 37.3 37.3-37.3c6.5-6.5 6.5-17.1 0-23.6s-17.1-6.5-23.6 0L49.9 35.7 36.2 22c-6.5-6.5-17.1-6.5-23.6 0z" className="st0" fill="#414042"></path></svg></div><span class='text-xs'>Add To Babylist Registry</span></span>`

const defaultImageSrc =
    'https://cdn.shopify.com/s/files/1/2338/2917/files/avatar-default-neutral.png?v=1690397466'

const freeRobes = [
    7265594540094, 7265596473406, 7265596604478, 7265596964926, 7265596997694,
    40242146738238, 40242161319998, 40242161352766, 40242161385534,
    40242161418302, 40242161516606, 40242161549374, 40242161582142,
    40242162532414, 40242162565182, 40242162597950, 40242162630718,
    40242162663486, 40242162696254,
]

const noReviews = [
    7520209371198, 7520209469502, 7520209338430, 7520209043518, 7520208977982,
    7145550938174, 7543796662334,
]

const Product = ({
    productData,
    slug,
    patternSlug,
    variantIdOnLoad,
    fromCart,
    registryItemId,
    currentP,
    productUrl,
}) => {
    // console.log('productData in Product.jsx', productData)

    const [cart, setCart] = useState()
    const [loaded, setLoaded] = useState(false)
    const $cartData = useStore(cartData)

    const $optionsData = useStore(optionsData || null)
    const { windowWidth, windowHeight } = useWindowDimensions()
    const [showStickyATC, setShowStickyATC] = useState(false)
    const [quantityDisabled, setQuantityDisabled] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [open, setOpen] = useState(false)
    const [slideIndex, setSlideIndex] = useState(0)
    const [isRestock, setIsRestock] = useState(false)
    const [showRestock, setShowRestock] = useState(false)
    const [currentVariants, setCurrentVariants] = useState([])
    const [noSizeError, setNoSizeError] = useState(false)
    const [isDoorbuster, setIsDoorbuster] = useState(false)
    //

    useEffect(() => {
        let observer = new IntersectionObserver((entries) => {
            if (entries[0].boundingClientRect.y < 0) {
                setShowStickyATC(true)
            } else {
                setShowStickyATC(false)
            }
        })
        observer.observe(document.querySelector('#pixel-to-watch'))
    }, [])

    let variantId

    const numberOfProducts = productData.total_product
    let products = productData.products

    let productIds

    // console.log('products', products)

    products = products.filter((p) => {
        return p.handle.includes(slug) && !freeRobes.includes(p.id)
    })

    productIds = products.map((p) => {
        return p.id
    })

    let currentProd
    let parentProductId
    let parentIdTagFound
    // let isRestock = false
    let vendor
    let productType
    let is20Off = false
    let is25Off = false
    let is30Off = false
    let is40Off = false
    let discountedPrice = null
    let hideReviews = false
    let noGots = false
    // let isDoorbuster = false

    if (currentP) {
        currentProd = currentP[0]

        const currentProductTags = currentProd?.tags
        vendor = currentProd?.vendor
        productType = currentProd?.product_type

        parentIdTagFound = currentProductTags?.find((element) => {
            return (
                element.includes('parentProductId') ||
                element.includes('parentProductID') ||
                element.includes('parentproductid')
            )
        })

        if (parentIdTagFound) {
            parentProductId = parentIdTagFound.split('_')[1]

            //
        }

        // if (currentProd?.tags.includes('restock')) {
        //     isRestock = true
        // }

        //

        if (currentProd?.id && noReviews.includes(currentProd?.id)) {
            hideReviews = true
        }

        if (vendor === 'Monica + Andy') {
            if (
                currentProductTags.some((tag) => tag.includes('disney')) ||
                currentProd[0]?.title.includes('SALE')
            ) {
                is30Off = false
            } else {
                //
                is30Off = true
                discountedPrice = currentProd[0]?.price_max * 0.7
                //
            }
        }

        // console.log(
        //     'parentProductId, currentProductTags',
        //     parentProductId,
        //     currentProductTags
        // )
    } else {
        currentProd = products.filter((p) => {
            let currentP = p.variants.map((v) => {
                // console.log ('v.id', v.id)
                if (v.id?.toString() === variantIdOnLoad?.toString()) {
                    //
                    return p
                }
            })

            return currentP[0]
        })

        setCurrentProduct(currentProd)

        const currentProductTags = currentProd[0]?.tags
        //

        parentIdTagFound = currentProductTags?.find((element) => {
            return (
                element.includes('parentProductId') ||
                element.includes('parentProductID') ||
                element.includes('parentproductid')
            )
        })

        if (parentIdTagFound) {
            parentProductId = parentIdTagFound.split('_')[1]
            //
        }

        // if (currentProd[0]?.tags.includes('restock')) {
        //     isRestock = true
        // }

        // if (
        // 	(vendor === 'Monica + Andy' &&
        // 		!currentProductTags.includes('disney')) ||
        // 	!currentProd?.title.includes('SALE')
        // ) {
        // 	is30Off = true

        // 	discountedPrice = currentProd[0]?.price_max * 0.7
        // } else {
        // 	discountedPrice = ''
        // 	is30Off = false
        // }

        // console.log(
        //     'parentProductId, currentProductTags below',
        //     parentProductId,
        //     currentProductTags
        // )
    }

    const [currentProduct, setCurrentProduct] = useState(currentProd)

    useEffect(() => {
        if (currentP) {
            currentProd = currentP[0]
        } else {
            currentProd = products.filter((p) => {
                let currentP = p.variants.map((v) => {
                    // console.log ('v.id', v.id)
                    if (v.id.toString() === variantIdOnLoad.toString()) {
                        //
                        return p
                    }
                })

                return currentP[0]
            })
        }

        setCurrentProduct(currentProd)

        const currentProductTags = currentProd?.tags

        if (currentProductTags?.includes('restock')) {
            setIsRestock(true)
        } else {
            setIsRestock(false)
            setShowRestock(false)
        }

        if (
            currentProductTags?.includes('no-gots') ||
            currentProductTags?.includes('nogots')
        ) {
            noGots = true
        }

        const vpitem = {
            Name: currentProd?.title || '',
            Price: currentProd?.price_max
                ? currentProd?.price_max
                : currentProd?.price
                ? currentProd?.price
                : '',
            ProductID: variantIdOnLoad
                ? variantIdOnLoad
                : currentProd?.variants[0]?.id,
            Categories: currentProd?.options_with_values,
            ImageURL: currentProd?.images_info[0]?.src,
            URL: window.location.href,
            Brand: currentProd?.vendor || 'Monica + Andy',
        }

        if (TriplePixel) {
            window.TriplePixelData.product = {
                id: currentProd?.id || '',
                name: currentProd?.title || '',
                price: currentProd?.price_max
                    ? currentProd?.price_max
                    : currentProd?.price
                    ? currentProd?.price
                    : '',
                variant: variantIdOnLoad
                    ? variantIdOnLoad
                    : currentProd?.variants[0]?.id,
            }
        }

        // geq.event('Viewed Product Reclaim', vpitem)
    }, [])

    useEffect(() => {
        if (currentProduct) {
            let currentProductTags = currentProduct.tags

            // console.log('currentProductTags', currentProductTags)
            if (currentProductTags.includes('restock')) {
                setIsRestock(true)
            } else {
                setIsRestock(false)
                setShowRestock(false)
            }

            if (currentProductTags.includes('doorbuster2024')) {
                setIsDoorbuster(true)
            } else {
                setIsDoorbuster(false)
            }
        }
    }, [currentProduct])

    //

    /* product data */
    let pages
    let productsFromData
    let hiddenProduct
    let mainProduct
    let allProducts = []
    let variants = []
    let variantsFromProducts = []
    let allVariants = []
    let productVideoUrl = ''

    let tags = []
    let currentProductTags = []
    let mainP = []

    let nogots = false

    let slugS = slugString(slug)

    if (products) {
        // // console.log here in product')
        productsFromData = productData.products

        //

        // ensure that product has all of slug in handle
        productsFromData = productsFromData.filter((p) => {
            // // console.log slug', slug)
            return p.handle.indexOf(slug) > -1
        })

        // console.log('productsFromData', productsFromData)

        let extraProducts = productsFromData.filter((p) => {
            return endsWithNumber(p.handle)
        })

        // // console.log extraProducts', extraProducts)

        let hiddenP = productsFromData.filter((p) => {
            return p.handle === slug && p.title.indexOf('hidden') > -1
        })

        hiddenProduct = hiddenP

        //

        if (
            hiddenP &&
            hiddenP.length > 0 &&
            hiddenP[0] &&
            hiddenP[0].metafields
        ) {
            let metafields = hiddenP[0].metafields
            productVideoUrl = metafields.find(
                (m) => m.key === 'url' && m.namespace === 'product_video'
            )?.value
        }

        let printProducts = productsFromData.filter((p) => {
            return p.handle.indexOf('_') !== -1
        })

        if (printProducts.length > 0) {
            productsFromData = printProducts
        }

        let mainProducts = productsFromData.filter((p) => {
            return p.handle.split('_')[0] === slug
        })

        mainProducts = mainProducts.reverse()

        let otherProducts = productsFromData.filter((p) => {
            return p.handle.split('_')[0] !== slug
        })

        let allProducts = [...mainProducts, ...otherProducts, ...extraProducts]

        //

        // setProducts(allProducts)

        if (mainProducts.length > 0) {
            mainP = [mainProducts[0]]
        } else {
            mainP = productsFromData.filter((p) => {
                return p.handle === slug
            })
        }

        if (mainP.length > 0 && mainP[0]) {
            let mainProductTags = mainP[0].tags
            //
            if (
                mainProductTags.includes('no-gots') ||
                mainProductTags.includes('nogots')
            ) {
                nogots = true
            } else if (
                (currentProductTags &&
                    currentProductTags.length > 0 &&
                    currentProductTags.includes('no-gots')) ||
                currentProductTags.includes('nogots')
            ) {
                nogots = true
            }
        }

        if (mainP.length === 0) {
            mainP = [productsFromData[0]]
        }

        mainProduct = mainP

        allProducts.map((p) => {
            variantsFromProducts.push(p.variants)
            return null
        })

        variantsFromProducts = variantsFromProducts.flat(1)

        allVariants = variantsFromProducts

        variantsFromProducts = variantsFromProducts.filter((v) => {
            if (v.product_type !== 'Virtual Classes') {
                return v.inventory_quantity > 0
            } else {
                return v
            }
        })

        variants = variantsFromProducts
    }

    let initialVariant = variants.filter((v) => {
        if (variantIdOnLoad) {
            return v.id.toString() === variantIdOnLoad.toString()
        }
        return null
    })

    // if we don't have a variantId in the URL, we'll use the first one
    if (!initialVariant || initialVariant.length === 0) {
        initialVariant = [variants[0]]
    }

    let initialColor
    //
    if (patternSlug && patternSlug !== '') {
        initialColor = unslugify(patternSlug)
        //
    } else if (
        initialVariant &&
        initialVariant[0] &&
        initialVariant[0].initial_color
    ) {
        initialColor = initialVariant[0].initial_color.replace(/\//g, ' ')
        //
    }

    // console.log('initialColor', initialColor)

    const [currentColor, setCurrentColor] = useState(initialColor || '')

    let productDescription
    let productTitle
    if (hiddenProduct && hiddenProduct[0]) {
        productDescription = hiddenProduct[0].body_html
        productTitle = hiddenProduct[0].title
    } else if (mainProduct && mainProduct[0]) {
        productDescription = mainProduct[0].body_html
        productTitle = mainProduct[0].title
    } else if (products && products[0]) {
        productDescription = products[0].body_html
        productTitle = products[0].title
    } else {
        productDescription = ''
    }

    let productDescriptionText = productDescription.split('::::')[0]
    //
    let valueProps

    if (productDescription.split('::::')[1]) {
        valueProps = productDescription.split('::::')[1].trim()
    }

    let valuePropsObj

    // valueProps = valueProps.split(':::')

    if (valueProps && valueProps.length > 0) {
        valueProps = valueProps.split(':::')
        //
        valuePropsObj = valueProps
            .map((v) => {
                //
                if (v === '' || v === '\n') {
                    return null
                }
                return {
                    title: v.split('::')[0],
                    description: v.split('::')[1]
                        ? v.split('::')[1].replace('\n', '')
                        : '',
                }
            })
            .filter((v) => v !== null)
    }

    //

    // let productTitle
    // if (mainProduct && mainProduct[0]) {
    //     productTitle = mainProduct[0].title
    // } else {
    //     productTitle = products[0].title
    // }

    productTitle = productTitle?.replace('SALE - ', '')
    productTitle = productTitle?.replace('[hidden]', '')

    /* embroidery */
    let embroidery = false

    const embroideredProducts = embroideryData.embroidery.products

    // // console.log embroideredProducts', embroideredProducts)

    if (embroideredProducts && embroideredProducts.length) {
        let obj = embroideredProducts.find((o) => o.productHandle === slug)
        //

        if (
            (currentProduct &&
                currentProduct?.handle === 'knit-overalls_red-hearts') ||
            currentProduct?.handle ===
                'short-sleeve-crewneck-tee_lightning-mcqueen' ||
            (currentProduct && currentProduct.tags.includes('disney')) ||
            (currentProduct && !currentProduct.tags.includes('embroidery2023'))
        ) {
            embroidery = false
        } else if (
            (obj && obj.productHandle !== '') ||
            (obj && obj.productHandle !== null)
        ) {
            embroidery = true
        }
    }

    const [colors, setColors] = useState({
        basicColors: [],
        limitedColors: [],
        trunkSaleColors: [],
    })

    const [position, setPosition] = useState({
        pos: 0,
        index: 0,
    })

    const [sizes, setSizes] = useState([])
    const [currentSize, setCurrentSize] = useState({
        size: '',
        variantId: '',
        sku: '',
    })

    const [quantity, setQuantity] = useState(1)
    const [hasSwatches, setHasSwatches] = useState(true)

    const [productOptions, setProductOptions] = useState({
        embroidery: false,
        embroiderySlug: '',
        embroideryFont: {},
        embroideryType: '',
        embroideryCharacterLimit: 20,
        embroideryColor: '',
        embroideryText: '',
        embroideryText2: '',
        embroideryPrice: 15,
        embroiderySubmitted: false,
        embroideryVerified: false,
        embroideryVariantId: '',
        embroideryError: {
            text: false,
            font: false,
            color: false,
        },
    })

    // useEffect(() => {}, [currentSize])

    useEffect(() => {
        // console.log('fromCart in Product.jsx', fromCart)
        if (fromCart && variantIdOnLoad && !registryItemId) {
            // console.log('variantIdOnLoad here', variantIdOnLoad)
            window.history.replaceState(
                null,
                null,
                window.location.origin +
                    window.location.pathname +
                    '?variant=' +
                    variantIdOnLoad
            )
        }

        if ($optionsData && !isEmpty($optionsData)) {
            if (
                $optionsData.embroiderySlug &&
                $optionsData.embroiderySlug !== slug
            ) {
                clearOptions()
            } else {
                setProductOptions({
                    ...productOptions,
                    ...$optionsData,
                })
                setQuantityDisabled($optionsData.embroidery)
            }
        } else {
            const defaultProductOptions = {
                embroidery: false,
                embroiderySlug: '',
                embroideryFont: {},
                embroideryType: '',
                embroideryCharacterLimit: 20,
                embroideryColor: '',
                embroideryText: '',
                embroideryText2: '',
                embroideryPrice: 15,
                embroiderySubmitted: false,
                embroideryVerified: false,
                embroideryVariantId: '',
                embroideryError: {
                    text: false,
                    font: false,
                    color: false,
                },
            }
            //
            optionsData.set(defaultProductOptions)
            setQuantityDisabled(false)
            setProductOptions({
                ...productOptions,
                ...defaultProductOptions,
            })
        }
        setIsLoading(false)
    }, [])

    const options = {
        settings: {
            overlayColor: 'rgba(248, 248, 248, 0.9)',
        },
    }

    const [embroideryError, setEmbroideryError] = useState(false)

    /* product images */
    let allProductImages = products.map((p) => {
        //
        // console.log('p', p, p.images_info)
        //
        let images = p.images_info.map((v, i) => {
            //

            const currentColorSlug = slugify(currentColor)

            //

            // console.log('v.alt', v.alt, p?.title)

            const [srcBefore, srcAfter] = splitLastOccurrence(v.src, '.')

            const imageSrc = srcBefore + '_1200x1800.' + srcAfter

            if (v.id === 33056594886718 || v.id === '33056594886718') {
                v.alt = 'pizza-party'
            }

            return {
                imageSrc: imageSrc,
                imageAlt: v.alt ? v.alt : '',
                position: v.position,
                colorSlug: v.alt ? v.alt : '',
                initial_color: v.alt ? unslugify(v.alt) : '',
                id: v.id,
            }
        })
        return images
    })

    allProductImages = allProductImages.flat(1)

    allProductImages = allProductImages.filter((p) => {
        // Filter out images with empty imageAlt or with 'ma-parent-hidden' in the imageSrc
        return (
            p.imageAlt &&
            p.imageAlt !== '' &&
            !p.imageSrc.includes('ma-parent-hidden')
        )
    })

    // console.log('allProductImages', allProductImages)

    let matchingProductImages = allProductImages.filter((p) => {
        if (patternSlug && patternSlug !== '') {
            return (
                p.initial_color.toString().toLowerCase() ===
                unslugify(patternSlug).toString().toLowerCase()
            )
        } else if (
            p.initial_color &&
            p.initial_color !== '' &&
            initialVariant &&
            initialVariant[0] &&
            initialVariant[0].initial_color
        ) {
            // console.log('p.initial_color', p.initial_color)
            // console.log('initialVariant[0].initial_color', initialVariant[0].initial_color)
            return (
                p.initial_color.toString().toLowerCase() ===
                initialVariant[0].initial_color.toString().toLowerCase()
            )
        } else {
            return p
        }

        return null
    })

    if (matchingProductImages.length === 0) {
        let match

        if (mainProduct && mainProduct[0]) {
            match = mainProduct[0].variants[0]

            matchingProductImages = [
                {
                    imageSrc: match.image
                        ? match.image
                        : mainProduct[0].images_info[0]?.src,
                    imageAlt: mainProduct[0].title,
                    position: 1,
                    colorSlug: match.initial_color,
                    initial_color: match.initial_color,
                    id: match.id,
                },
            ]
        } else if (mainP && mainP[0]) {
            //
            matchingProductImages = [
                {
                    imageSrc: mainP[0].images_info[0].src,
                    imageAlt: '',
                    position: 1,
                    colorSlug: '',
                    initial_color: '',
                    id: '',
                },
            ]
        }
    }

    matchingProductImages = getUniqueListBy(matchingProductImages, 'imageSrc')

    // console.log('matchingProductImages', matchingProductImages)

    // for classes + unsized items, use the first image
    if (
        mainProduct &&
        mainProduct[0] &&
        mainProduct[0].product_type === 'Virtual Classes'
    ) {
        matchingProductImages = [matchingProductImages[0]]
    }

    let matchingProduct = useMemo(() => [], [])
    let productImageSrc = ''

    if (variantIdOnLoad) {
        matchingProduct = variants.filter((v) => {
            return v.id.toString() === variantIdOnLoad.toString()
        })
        //
        if (matchingProduct && matchingProduct.length) {
            productImageSrc = matchingProduct[0].image
        } else {
            matchingProduct = [mainProduct[0]]
            productImageSrc = matchingProductImages[0]?.imageSrc
        }
    } else if (patternSlug && patternSlug !== '') {
        // matchingProduct = [mainProduct[0]]
        matchingProduct = products.filter((p) => {
            //
            // return null
            if (p.options_with_values && p.options_with_values.length > 0) {
                return (
                    p.options_with_values[0].values[0].title
                        .toString()
                        .toLowerCase() ===
                    unslugify(patternSlug).toString().toLowerCase()
                )
            }
            // return p.initial_color.toString().toLowerCase === unslugify(patternSlug).toString().toLowerCase()
        })

        if (matchingProduct && matchingProduct.length) {
            productImageSrc = matchingProduct[0].images_info[0].src
        }
    } else {
        if (
            matchingProductImages &&
            matchingProductImages[0]?.imageSrc === null
        ) {
            productImageSrc = mainProduct[0].images_info[0].src

            matchingProductImages = [
                {
                    imageSrc: productImageSrc,
                    imageAlt: 'product image',
                    position: 1,
                    colorSlug: '',
                    initial_color: '',
                    id: '',
                },
            ]
        } else if (variants && variants.image) {
            productImageSrc = variants[0].image
        } else if (
            matchingProductImages &&
            matchingProductImages.length &&
            matchingProductImages[0].imageSrc
        ) {
            productImageSrc = matchingProductImages[0].imageSrc
        } else {
            productImageSrc = matchingProduct[0]?.images_info[0]?.src
        }

        //
    }

    const [srcBefore, srcAfter] = splitLastOccurrence(
        productImageSrc ? productImageSrc : '',
        '.'
    )

    //

    productImageSrc = srcBefore + '_1200x1800' + srcAfter

    const [mainImage, setMainImage] = useState({
        src: productImageSrc,
        alt: productTitle ? productTitle : 'product image',
        initial_color:
            (variants &&
                variants[0] &&
                variants[0].initial_color &&
                variants[0].initial_color) ||
            (mainProduct &&
                mainProduct[0] &&
                mainProduct[0].options_with_values &&
                mainProduct[0].options_with_values[0] &&
                mainProduct[0].options_with_values.values[0] &&
                mainProduct[0].options_with_values.values[0].title),
    })

    const [mainImageStyle, setMainImageStyle] = useState({
        backgroundImage: mainImage ? `url(${mainImage.src})` : '',
        backgroundPosition: '0% 0%',
    })

    const [currentImages, setCurrentImages] = useState(matchingProductImages)
    const [slides, setSlides] = useState()

    const [currentPrice, setCurrentPrice] = useState({
        price:
            (currentProd && currentProd[0] && currentProd[0]?.price) ||
            currentProd?.price ||
            (initialVariant && initialVariant[0] && initialVariant[0]?.price) ||
            (hiddenProduct && hiddenProduct[0] && hiddenProduct[0]?.price) ||
            (mainProduct && mainProduct[0] && mainProduct[0]?.price) ||
            (matchingProduct &&
                matchingProduct[0] &&
                matchingProduct[0]?.price) ||
            (variants && variants[0] && variants[0]?.price),
        compareAtPrice:
            (currentProduct && currentProduct.compare_at_price_max === null
                ? null
                : currentProduct?.compare_at_price_max) || '',
        discountPrice: discountedPrice || '',
    })

    // const [currentDiscountPrice, setCurrentDiscountPrice] =
    // 	useState(discountedPrice)

    /* swatches */
    let swatches = useMemo(() => [], [])
    variants.map((v) => {
        if (currentProd[0]?.vendor === 'Monica + Andy') {
            if (v.initial_color && v.inventory_quantity > 0) {
                swatches.push(v.initial_color)
            }
        } else {
            if (v.initial_color) {
                swatches.push(v.initial_color)
            }
        }
        return null
    })

    swatches = [...new Set(swatches)]

    // console.log('swatches', swatches)

    useEffect(() => {
        if (!swatches || swatches.length === 0) {
            setHasSwatches(false)
        }
    }, [swatches])

    let variantColors = []
    let basicColors = []
    let limitedColors = []
    let trunkSaleColors = []
    let sortedSwatches = []
    let matchingVariants = []

    const sortedColors = useRef(null)

    useEffect(() => {
        let marketplaceVariants = []
        variantColors = productColors.products

        if (products && products.length === 1) {
            const tags = products[0].tags

            if (
                (products[0].available_locations &&
                    products[0].available_locations?.includes('61535060030')) ||
                products[0].available_locations?.includes(61535060030) ||
                products[0].available_locations?.includes('60903981118') ||
                products[0].available_locations?.includes(60903981118) ||
                products[0].available_locations?.includes('64438763582') ||
                products[0].available_locations?.includes(64438763582) ||
                products[0].locations?.includes('instock:logicbroker') ||
                products[0]?.vendor !== 'Monica + Andy'
            ) {
                //
                marketplaceVariants = products[0].variants
            } else if (tags.includes('dropship')) {
                //
                marketplaceVariants = products[0].variants
            }
        }

        // console.log('marketplaceVariants', marketplaceVariants)

        products.map((p) => {
            variantColors.map((c) => {
                // console.log('c', c)
                if (p.id.toString() === c.product_id.toString()) {
                    if (c.basic_colors !== '') {
                        basicColors.push(p)
                    } else if (c.trunk_sale_colors !== '') {
                        trunkSaleColors.push(p)
                    }
                }
            })
        })

        let extraColors = [...basicColors, ...trunkSaleColors]

        //

        // eslint-disable-next-line
        limitedColors = products.filter((x) => !extraColors.includes(x))

        //

        // eslint-disable-next-line
        swatches.map((s) => {
            if (basicColors && basicColors.length) {
                basicColors.map((b) => {
                    if (
                        b.variants[0] &&
                        b.variants[0].initial_color &&
                        b.variants[0].initial_color.toString() === s.toString()
                    ) {
                        sortedSwatches.push({
                            color: s,
                            colorType: 'basic',
                        })
                    }
                    return null
                })
            }
            if (trunkSaleColors && trunkSaleColors.length) {
                trunkSaleColors.map((t) => {
                    // console.log('t', t)
                    if (
                        t.variants[0] &&
                        t.variants[0].initial_color &&
                        t.variants[0].initial_color.toString() === s.toString()
                    ) {
                        sortedSwatches.push({
                            color: s,
                            colorType: 'trunkSale',
                        })
                    }
                    return null
                })
            }
            if (limitedColors && limitedColors.length) {
                limitedColors.map((l) => {
                    // // console.log l', l)
                    if (
                        l.variants[0] &&
                        l.variants[0].initial_color &&
                        l.variants[0].initial_color.toString() === s.toString()
                    ) {
                        sortedSwatches.push({
                            color: s,
                            colorType: 'limited',
                        })
                    }
                    return null
                })
            }
        })

        if (marketplaceVariants && marketplaceVariants.length) {
            marketplaceVariants.map((v) => {
                if (v.initial_color && v.inventory_quantity > 0) {
                    sortedSwatches.push({
                        color: v.initial_color,
                        colorType: 'marketplace',
                    })
                }
            })
        }

        sortedColors.current = getUniqueListBy(sortedSwatches, 'color')

        sortedColors.current = groupBy(sortedColors.current, 'colorType')

        // console.log('sortedColors.current', sortedColors.current)

        setColors({
            basicColors: sortedColors.current.basic,
            trunkSaleColors: sortedColors.current.trunkSale,
            limitedColors: sortedColors.current.limited,
            marketplaceColors: sortedColors.current.marketplace,
        })
    }, [])

    /* sizes */

    useEffect(() => {
        let initialSizes = []

        allVariants.map((v) => {
            if (v.initial_size && v.initial_color === currentColor) {
                initialSizes.push({
                    variantId: v.id,
                    inventory_quantity: v.inventory_quantity,
                    sku: v.sku,
                    productId: v.product_id,
                    price: v.price,
                    initial_size: v.initial_size,
                })
            } else if (
                (currentProduct && currentProduct?.tags.includes('dropship')) ||
                currentProduct?.tags.includes('Shopify Collective')
            ) {
                initialSizes.push({
                    variantId: v.id,
                    inventory_quantity: v.inventory_quantity,
                    sku: v.sku,
                    productId: v.product_id,
                    price: v.price,
                    initial_size: v.initial_size,
                })
            }
            return null
        })

        initialSizes = initialSizes.filter(function (e) {
            return (
                e.initial_size !== null &&
                e.initial_size !== undefined &&
                e !== ''
            )
        })

        if (initialSizes.length > 0) {
            let sortedSizeList = initialSizes.sort(sizeSortFunc)

            sortedSizeList = getUniqueListBy(sortedSizeList, 'initial_size')

            sortedSizeList = sortedSizeList.filter(function (e) {
                return e !== null && e !== undefined && e !== ''
            })

            if (sortedSizeList.length > 0) {
                setSizes(sortedSizeList)
            }
        } else {
            setCurrentSize({
                size: 'nosize',
                variantId:
                    initialVariant && initialVariant[0] && initialVariant[0].id,
                sku:
                    initialVariant &&
                    initialVariant[0] &&
                    initialVariant[0].sku,
            })
            setSizes([])
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (currentImages && currentImages.length > 0) {
            let imagesAsSlides = currentImages.map((m, i) => {
                const [srcBefore, srcAfter] = splitLastOccurrence(
                    m.imageSrc,
                    '.'
                )
                let imageSrc = srcBefore
                // Replace only the last occurrence of _1200x1800 before the extension
                imageSrc = imageSrc.replace(/_1200x1800([^_.]*)$/, '_2400x3600')
                imageSrc = imageSrc + '.' + srcAfter
                // console.log(
                //     'imageSrc in useEffect',
                //     imageSrc,
                //     srcBefore,
                //     srcAfter
                // )
                return {
                    src: imageSrc,
                    alt: m.imageAlt ? m.imageAlt : '',
                }
            })

            setSlides(imagesAsSlides)
        }
    }, [currentImages])

    useEffect(() => {
        chord.trackProductViewed({
            cart,
            product: {
                product: currentProduct,
                quantity,
                variantId: currentSize?.variantId || initialVariant?.[0]?.id,
            },
        })

        //
        dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'dl_view_item',
            ecommerce: {
                items: [
                    {
                        item_id: String(
                            variantIdOnLoad ? variantIdOnLoad : variantId
                        ),
                        item_name: productTitle ? productTitle : '',
                        affiliation: 'Vercel',
                        item_brand: 'Monica + Andy',
                        item_category: currentColor ? currentColor : '',
                        item_category2: currentSize?.size,
                        item_variant: String(currentSize?.variantId),
                        price: Number(currentPrice?.price),
                        quantity: quantity ? quantity : 1,
                    },
                ],
            },
        })

        dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'GA4_view_item',
            page: 'pdp',
            ecommerce: {
                currency: 'USD',
                value: Number(currentPrice?.price),
                items: [
                    {
                        item_id: String(
                            variantIdOnLoad ? variantIdOnLoad : variantId
                        ),
                        item_name: productTitle ? productTitle : '',
                        affiliation: 'Vercel',
                        item_brand: 'Monica + Andy',
                        item_category: currentColor ? currentColor : '',
                        item_category2: currentSize?.size,
                        item_variant: String(currentSize?.variantId),
                        price: Number(currentPrice?.price),
                        quantity: quantity ? quantity : 1,
                    },
                ],
            },
        })

        const vpitem = {
            Name: currentProd?.title || '',
            Price: currentProd?.price_max
                ? currentProd?.price_max
                : currentProd?.price
                ? currentProd?.price
                : '',
            ProductID: variantIdOnLoad
                ? variantIdOnLoad
                : currentProd?.variants[0]?.id,
            Categories: currentProd?.options_with_values,
            ImageURL: currentProd?.images_info[0]?.src,
            URL: window.location.href,
            Brand: currentProd?.vendor || 'Monica + Andy',
        }

        if (vpitem) {
            // geq.event('Viewed Product Reclaim', vpitem)
        }
    }, [])

    const handleImageClick = (
        e,
        colorSlug,
        initialColor,
        imageSrc,
        imageAlt,
        index
    ) => {
        e.preventDefault()
        let imageSelected = document.querySelector('.image-selected')

        imageSelected.classList.remove('image-selected')

        // find matching image node; add class
        let matchingImageNode = document.querySelector(
            '[data-index="' + index + '"]'
        )
        matchingImageNode.classList.add('image-selected')

        setMainImage({
            src: imageSrc,
            alt: imageAlt ? imageAlt : 'product image',
            initial_color: initialColor,
        })

        setCurrentColor(initialColor)

        setPosition({
            ...position,
            index: index,
        })
    }

    const handleImageNavigation = (e, direction, index) => {
        const imageArrayLength = currentImages.length
        const element = document.getElementById('image-grid')
        const positionInfo = element.getBoundingClientRect()
        const width = positionInfo.width
        const tileWidth = width / imageArrayLength
        let currentIndex = index

        let newPosition

        if (direction === 'right') {
            if (currentIndex === imageArrayLength - 1) {
                currentIndex = 0
                newPosition = 0 // Reset to the initial position
            } else {
                currentIndex++
                newPosition = -tileWidth * currentIndex
            }

            element.style.transform = `translateX(${newPosition}px)`
        }

        if (direction === 'left') {
            if (currentIndex === 0) {
                currentIndex = imageArrayLength - 1
            } else {
                currentIndex--
            }

            newPosition = -tileWidth * currentIndex

            element.style.transform = `translateX(${newPosition}px)`

            // document.querySelector('.images-nav').scrollLeft += newPosition
        }
    }

    const handleSizeClick = (
        size,
        variantId,
        index,
        sku,
        inventory_quantity
    ) => {
        if (inventory_quantity === 0 && isRestock) {
            setShowRestock(true)
            setCurrentSize({
                size: size,
                variantId: variantId,
                sku: sku,
            })
            setNoSizeError(false)
            return
        }

        let btnEl = document.querySelectorAll(`.registry-trigger`)

        btnEl.forEach((i) => (i.innerHTML = registryHtml))

        replaceUrlParam('variant', variantId)
        // let el = document.querySelectorAll('.registry-actions')
        // el[0].firstChild.innerText = 'Add To Babylist Registry'
        // let ele = document.getElementsByClassName('size size-selected')
        // if (ele.length > 0) {
        //     ele[0].classList.remove('size-selected')
        // }
        setCurrentSize({
            size: size,
            variantId: variantId,
            sku: sku,
        })
        setQuantity(1)
        setNoSizeError(false)
    }

    const handleQuantityDecrement = () => {
        if (productOptions && productOptions.embroidery) {
            setQuantityDisabled(true)
            return
        }

        setQuantity((prevQuantity) => {
            if (prevQuantity === 1) {
                return 1
            }
            if (prevQuantity === 0) {
                return 1
            }
            return prevQuantity - 1
        })
    }

    const handleQuantityChange = (e) => {
        if (productOptions && productOptions.embroidery) {
            setQuantityDisabled(true)
            return
        }
        let value = e.target.value
        if (value > 0 && value < 100) {
            setQuantity(value)
        }
    }

    const handleQuantityIncrement = () => {
        if (productOptions && productOptions.embroidery) {
            setQuantityDisabled(true)
            return
        }

        const min = 0
        const max = 99
        let value = parseInt(quantity)

        value += 1

        if (value > max) value = max
        if (value < min) value = min

        setQuantity(value)
    }

    const handleSwatchClick = (swatchSlug, swatchTitle, index) => {
        // let ele = document.getElementsByClassName('size size-selected')
        // if (ele.length > 0) {
        //     ele[0].classList.remove('size-selected')
        // }
        console.log('swatch clicked', swatchSlug, swatchTitle)

        // console.log('currentSize in handleSwatchClick', currentSize)

        let btnEl = document.querySelectorAll(`.registry-trigger`)
        const html = `<span className="flex items-center justify-center gap-2 "><div className='heart-icon w-[24px]'><svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" enableBackground="new 0 0 100 100" version="1.1" viewBox="0 0 100 100" xmlSpace="preserve"><path d="M49.9 91.9L8.1 50.1c-9-9-9-23.6 0-32.6s23.6-9 32.6 0l9.2 9.2 9.2-9.2c9-9 23.6-9 32.6 0s9 23.6 0 32.6L49.9 91.9zM12.6 22c-6.5 6.5-6.5 17.1 0 23.6l37.3 37.3 37.3-37.3c6.5-6.5 6.5-17.1 0-23.6s-17.1-6.5-23.6 0L49.9 35.7 36.2 22c-6.5-6.5-17.1-6.5-23.6 0z" className="st0" fill="#414042"></path></svg></div>Add To Babylist Registry</span>`
        btnEl.forEach((i) => (i.innerHTML = registryHtml))

        setQuantity(1)

        swatchTitle = swatchTitle.replace(/\//g, ' ')

        if (swatchTitle !== currentColor) {
            setCurrentColor(swatchTitle)
            setPosition({
                ...position,
                index: 0,
            })
        } else {
            setPosition({
                ...position,
                index: index,
            })
        }

        console.log('allProductImages in handleSwatchClick', allProductImages)

        let newImages = allProductImages.filter((n, i) => {
            // console.log(
            //     slugify(swatchTitle).toLowerCase(),
            //     slugify(n.initial_color).toLowerCase()
            // )
            if (n.initial_color) {
                return (
                    slugify(n.initial_color).toLowerCase() ===
                    slugify(swatchTitle).toLowerCase()
                )
            } else {
                return i === index
            }
        })

        newImages = getUniqueListBy(newImages, 'imageSrc')

        console.log('newImages in handleSwatchClick', newImages)

        newImages = newImages.filter((p) => {
            // Filter out images with empty imageAlt or with 'ma-parent-hidden' in the imageSrc
            return (
                p.imageAlt &&
                p.imageAlt !== '' &&
                !p.imageSrc.includes('ma-parent-hidden')
            )
        })

        setCurrentImages(newImages)

        let matchingVs = allVariants.filter((v) => {
            return v.initial_color === swatchTitle
        })

        let matchingId = matchingVs[0].id

        let currentProd = products.filter((p) => {
            let currentP = p.variants.map((v) => {
                //
                if (v.id.toString() === matchingId.toString()) {
                    return p
                }
            })
            return currentP[0]
        })

        if (currentProd && !isEmpty(currentProd[0])) {
            setCurrentProduct(currentProd[0])
            const currentProductTags = currentProd[0].tags
            setIsDoorbuster(
                currentProductTags?.includes('doorbuster2024') || false
            )
        } else {
            setCurrentProduct(mainProduct[0])
            const currentProductTags = mainProduct[0].tags
            setIsDoorbuster(
                currentProductTags?.includes('doorbuster2024') || false
            )
        }

        // console.log('currentProd', currentProd)

        if (newImages && newImages.length > 0) {
            setMainImage({
                src: newImages[0].imageSrc,
                alt: newImages[0].imageAlt
                    ? newImages[0].imageAlt
                    : 'product image',
                initial_color: newImages[0].initial_color,
            })
        } else {
            let matchingV = variants.filter((v) => {
                return v.initial_color === swatchTitle
            })
            // // console.log matchingV', matchingV)
            setMainImage({
                src: matchingV[0].image,
                alt: slugify(swatchTitle),
                initial_color: swatchTitle,
            })
            setCurrentImages([
                {
                    imageSrc: matchingV[0].image,
                    imageAlt: slugify(swatchTitle),
                    initial_color: swatchTitle,
                },
            ])
        }

        matchingVariants = allVariants.filter((v) => {
            return v.initial_color === swatchTitle
        })

        if (matchingVariants && matchingVariants.length > 0) {
            setCurrentVariants(matchingVariants)
        }

        let matchingVariantSizes = []

        matchingVariants.map((v) => {
            // // console.log v', v)
            if (v.initial_size && v.initial_size !== '') {
                matchingVariantSizes.push({
                    variantId: v.id,
                    inventory_quantity: v.inventory_quantity,
                    sku: v.sku,
                    productId: v.product_id,
                    price: v.price,
                    initial_size: v.initial_size,
                })
            }

            return null
        })

        matchingVariantSizes = getUniqueListBy(
            matchingVariantSizes,
            'initial_size'
        )

        setSizes(matchingVariantSizes)

        if (
            currentSize.size &&
            currentSize.size !== '' &&
            currentSize.size !== null &&
            currentSize.size !== 'nosize'
        ) {
            // console.log('currentSize in handleSwatchClick here', currentSize)
            let matchingVariant = matchingVariants.filter((v) => {
                // First try to find variant with matching size and positive inventory
                if (
                    v.initial_size === currentSize.size &&
                    v.inventory_quantity > 0
                ) {
                    return true
                }
                return false
            })
            // If no matching variant with inventory found, get first variant with inventory > 0
            if (matchingVariant.length === 0) {
                matchingVariant = matchingVariants.filter(
                    (v) => v.inventory_quantity > 0
                )
            }

            // Take first matching variant if any found
            matchingVariant =
                matchingVariant.length > 0 ? [matchingVariant[0]] : []

            if (matchingVariant && matchingVariant[0]) {
                if (!registryItemId || registryItemId === '') {
                    replaceUrlParam('variant', matchingVariant[0].id)
                }
                setCurrentPrice({
                    price: matchingVariant[0].price,
                    compareAtPrice: matchingVariant[0].compareAtPrice,
                })
                setCurrentSize({
                    size: matchingVariant[0].initial_size,
                    variantId: matchingVariant[0].id,
                    sku: matchingVariant[0].sku,
                })
            }
        } else {
            let matchingId = matchingVariants[0].id
            let matchingVariantProductId = matchingVariants[0].product_id

            let matchingProduct = products.filter((p) => {
                return p.id === matchingVariantProductId
            })

            // // console.log matchingProduct', matchingProduct)

            if (!registryItemId || registryItemId === '') {
                replaceUrlParam('variant', matchingVariants[0].id)
            }

            //
            setCurrentPrice({
                price: matchingVariants[0].price,
                compareAtPrice:
                    matchingVariants[0].compareAtPrice ||
                    matchingVariants[0].compare_at_price,
            })
            // update url param
            if (!registryItemId || registryItemId === '') {
                replaceUrlParam('variant', matchingId)
            }
            if (currentSize.size === 'nosize') {
                setCurrentSize({
                    size: 'nosize',
                    variantId: matchingId,
                })
            } else {
                setCurrentSize({
                    size: '',
                    variantId: matchingId,
                })
                setNoSizeError(false)
            }
        }
        // let sizeSelector = document.getElementsByClassName('size-text')
        // if (sizeSelector.length > 0) {
        //     let el = document.querySelectorAll('.registry-actions')
        //     el[0].firstChild.classList.add('disabled')
        //     el[0].firstChild.innerText = 'Add To Babylist Registry'
        // }

        // matchingVariantSizes.map((s, i) => {
        //     if (currentSize.size === s.initial_size) {
        //         setCurrentSize(s)
        //         handleSizeClick(
        //             s.initial_size,
        //             s.variantId,
        //             i,
        //             s.sku,
        //             s.inventory_quantity
        //         )
        //     } else {
        //         setCurrentSize('')
        //     }
        //     return null
        // })
    }

    const handleOptions = (e, options) => {
        //

        const eData = embroideryData.embroidery
        const embroideryProducts = eData.products

        let embroideryProduct = embroideryProducts.filter((p) => {
            return p.productHandle === slug
        })

        let btnEl = document.querySelectorAll(`.registry-trigger`)
        btnEl.forEach((i) => (i.innerHTML = registryHtml))

        let dataOption = e.target.getAttribute('data-option')
        let dataChecked = e.target.checked

        let type

        if (options && options === 'type') {
            type = e.target.value
        }

        //

        // clear embroidery options if embroidery is unchecked
        if (options && options.embroidery === false) {
            //
            setQuantityDisabled(false)
            clearOptions()
            return
        }

        // get the variantId of the product we are embroidering
        let variantId = document.getElementById('variant-id').value
        //

        let text
        let text2
        let font
        let charLimit = embroideryProduct[0]?.characterLimit || 20
        let color
        let verified = false

        if (options && options.verified) {
            verified = options.verified
        }

        if (options && options.error) {
            let errors = {
                text: false,
                font: false,
                color: false,
            }
            //
            if (
                productOptions.embroideryText === '' ||
                !productOptions.embroideryText ||
                isEmpty(productOptions.embroideryText)
            ) {
                errors.text = true
            }
            if (
                productOptions.embroideryFont === '' ||
                !productOptions.embroideryFont ||
                isEmpty(productOptions.embroideryFont)
            ) {
                errors.font = true
            }
            if (
                productOptions.embroideryColor === '' ||
                !productOptions.embroideryColor ||
                isEmpty(productOptions.embroideryColor)
            ) {
                errors.color = true
            }

            const optionsObject = {
                ...productOptions,
                embroideryError: errors,
                embroideryVerified: false,
            }

            setProductOptions(optionsObject)
            optionsData.set(optionsObject)

            return
        }

        if (e.target.name === 'addEmbroidery') {
            const optionsObj = {
                ...productOptions,
                embroidery: !productOptions.embroidery,
                embroiderySlug: slug,
                embroideryVariantId: productOptions.embroidery ? variantId : '',
                embroideryCharacterLimit: charLimit,
            }
            setQuantity(1)
            setQuantityDisabled(!productOptions.embroidery)
            setProductOptions(optionsObj)
            optionsData.set(optionsObj)
        }

        if (type && e.target.value === 'Mama') {
            font = {
                webName: 'Mama',
                fontName: 'Boucherie',
                displayName: 'Mama',
            }
            const optionsObj = {
                ...productOptions,
                embroideryType: 'Mama',
                embroideryFont: font,
                embroideryText: 'Mama',
                embroideryCharacterLimit: 4,
            }

            setProductOptions(optionsObj)
            optionsData.set(optionsObj)
        }

        if (type && e.target.value === 'Monogram') {
            font = {
                webName: 'Monogram',
                fontName: 'Round Monogram',
                displayName: 'Monogram',
            }
            const optionsObj = {
                ...productOptions,
                embroideryType: 'Monogram',
                embroideryFont: font,
                embroideryText: '',
                embroideryCharacterLimit: 3,
            }

            setProductOptions(optionsObj)
            optionsData.set(optionsObj)
        }

        if (e.target.name === 'embroideryText') {
            text = e.target.value
            text = trimLeadingSpaces(text)

            //
            let font
            let monogram = false
            let athletic = false
            let mama = false

            if (productOptions.embroideryFont) {
                font = productOptions.embroideryFont
            }

            if (font && font.displayName && font.displayName === 'Monogram') {
                monogram = true
            }

            if (font && font.displayName && font.displayName === 'Athletic') {
                athletic = true
            }

            if (
                (monogram && text.length > 0) ||
                (athletic && text.length > 0)
            ) {
                text = text.replace(
                    /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
                    ''
                )
            }

            if (!monogram && !athletic) {
                charLimit = embroideryProduct[0].characterLimit
            }

            if (monogram) {
                charLimit = 3

                //
            } else if (athletic) {
                charLimit = 1
            }

            const optionsObj = {
                ...productOptions,
                embroideryText: text,
                embroiderySubmitted: false,
                embroideryCharacterLimit: charLimit,
                embroideryError: {
                    ...embroideryError,
                    text: false,
                },
                // embroideryVerified: text.length > 0 ? true : false,
            }

            setProductOptions(optionsObj)
            optionsData.set(optionsObj)
        }

        if (e.target.name === 'embroideryText2') {
            text2 = e.target.value
            text2 = trimLeadingTrailingSpaces(text2)
            //
            const optionsObj = {
                ...productOptions,
                embroideryText2: text2,
                embroiderySubmitted: false,
            }

            setProductOptions(optionsObj)
            optionsData.set(optionsObj)
        }

        if (dataOption && dataOption === 'embroideryFont') {
            font = {
                webName: options.webName,
                fontName: options.fontName,
                displayName: options.displayName,
            }

            let monogram = false
            let athletic = false

            if (font.displayName === 'Monogram') {
                monogram = true
                athletic = false
            }

            if (font.displayName === 'Athletic') {
                athletic = true
                monogram = false
            }

            if (font.displayName === 'Mama') {
            }

            // if (!monogram && !athletic) {
            //     charLimit = 20
            // }

            if (monogram) {
                charLimit = 3
            } else if (athletic) {
                charLimit = 1
            }

            let text = productOptions.embroideryText
            let text2 = productOptions.embroideryText2
            let length = charLimit
            let trimmedString = ''
            let trimmedString2 = ''
            if (text) {
                trimmedString = text.substring(0, length)
            }
            if (text2) {
                trimmedString2 = text2.substring(0, length)
            }
            if (monogram && trimmedString) {
                trimmedString = trimmedString.replace(
                    /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
                    ''
                )
            }

            if (monogram && trimmedString2) {
                trimmedString2 = trimmedString2.replace(
                    /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
                    ''
                )
            }

            const optionsObj = {
                ...productOptions,
                embroideryFont: font,
                embroideryText: trimmedString,
                embroideryText2: trimmedString2,
                embroideryCharacterLimit: charLimit,
                embroiderySubmitted: false,
                embroideryError: {
                    ...embroideryError,
                    font: false,
                },
            }
            setProductOptions(optionsObj)
            optionsData.set(optionsObj)
        }

        if (dataOption && dataOption === 'embroideryColor') {
            color = {
                threadColor: options.threadColor,
                name: options.name,
                hex: options.hex,
            }
            const optionsObj = {
                ...productOptions,
                embroideryColor: color,
                embroiderySubmitted: false,
                embroideryError: {
                    ...embroideryError,
                    color: false,
                },
            }
            setProductOptions(optionsObj)
            optionsData.set(optionsObj)
        }

        if (dataOption && dataOption === 'embroiderySubmitted') {
            const optionsObj = {
                ...productOptions,
                embroiderySubmitted: true,
                embroideryVerified: verified,
            }

            setProductOptions(optionsObj)
            optionsData.set(optionsObj)
        }
    }

    const clearOptions = (e) => {
        //
        if (
            e &&
            e.target &&
            e.target.classList.contains('options-clear-button')
        ) {
            const optionsObj = {
                embroidery: true,
                embroiderySlug: '',
                embroideryText: '',
                embroideryText2: '',
                embroideryFont: {},
                embroideryColor: {},
                embroideryPrice: 15,
                embroiderySubmitted: false,
                embroideryVerified: false,
                embroideryVariantId: '',
                embroideryError: {
                    text: false,
                    font: false,
                    color: false,
                },
            }

            setProductOptions(optionsObj)
            optionsData.set(optionsObj)
        } else {
            const optionsObj = {
                embroidery: false,
                embroiderySlug: '',
                embroideryText: '',
                embroideryText2: '',
                embroideryFont: {},
                embroideryColor: {},
                embroideryPrice: 15,
                embroiderySubmitted: false,
                embroideryVerified: false,
                embroideryVariantId: '',
                embroideryError: {
                    text: false,
                    font: false,
                    color: false,
                },
            }

            setProductOptions(optionsObj)
            optionsData.set(optionsObj)
        }

        // document.getElementById('pdp-embroidery').scrollIntoView()
    }

    useEffect(() => {
        // get the variantId of the product we are embroidering
        const parsed = qs.parse(window.location.search)
        let variantId = parsed.variant
        //
        if (variantId && productOptions && productOptions.embroideryVariantId) {
            if (variantId.toString() === productOptions.embroideryVariantId) {
                sessionStorage.setItem(
                    'productOptions',
                    JSON.stringify(productOptions)
                )
            } else {
                sessionStorage.removeItem('productOptions')
            }
        }
        //
    }, [productOptions])

    const handleAddToCart = async (e) => {
        const productSizes = document.getElementById('product-sizes')
        const productSwatches = document.querySelector('.product-swatches')
        if (!currentSize.size) {
            if (windowWidth < 768) {
                productSizes.scrollIntoView()
            } else {
                setNoSizeError(true)
                productSwatches.scrollIntoView()
                setTimeout(() => {
                    window.scrollBy(0, -10)
                }, 200)
            }
            return
        }

        if (embroidery && !currentSize.size) {
            alert('Please select a size before adding to cart.')

            if (windowWidth < 768) {
                productSizes.scrollIntoView()
            } else {
                setNoSizeError(true)
                productSwatches.scrollIntoView()
                setTimeout(() => {
                    window.scrollBy(0, -10)
                }, 200)
            }
            return
        }
        if (embroidery) {
            setIsLoading(true)
        }
        const noClick = e.target.classList.contains('noclick')

        if (noClick) {
            return
        }

        e.preventDefault()

        const cje = getCookie('cje') || 'cje_cookie'

        let cartId = $cartData?.cartId || ''

        let $options = optionsData.get()

        // if (
        //     $options &&
        //     $options.embroidery == true &&
        //     $options.embroiderySubmitted == false
        // ) {
        //     alert(
        //         'Please submit your embroidery options before adding to cart.'
        //     )
        //     return
        // }

        // console.log cartData in addToCart on PDP', $cartData)

        let variantId = currentSize.variantId

        const product = `gid://shopify/ProductVariant/${variantId}`

        let lines

        if ($options && $options.embroidery) {
            console.log('embroidery', $options.embroidery)
            lines = [
                {
                    merchandiseId:
                        'gid://shopify/ProductVariant/39726235418686',
                    quantity: 1,
                    attributes: [
                        {
                            key: 'variantId',
                            value: `${variantId}`,
                        },
                        {
                            key: 'SKU',
                            value: 'embroidery',
                        },
                    ],
                },
                {
                    merchandiseId: product,
                    quantity: quantity,
                    attributes: [
                        {
                            key: 'Add Embroidery?',
                            value: $options.embroidery === true ? '✓ Yes' : '',
                        },

                        {
                            key: 'Text',
                            value:
                                $options.embroideryText !== ''
                                    ? $options.embroideryText
                                    : '',
                        },
                        {
                            key: 'Text2',
                            value:
                                $options.embroideryText2 !== ''
                                    ? $options.embroideryText2
                                    : 'n/a',
                        },
                        {
                            key: 'Web Font',
                            value: $options.embroideryFont
                                ? $options.embroideryFont.webName
                                : '',
                        },
                        {
                            key: 'Font Name',
                            value: $options.embroideryFont
                                ? $options.embroideryFont.fontName
                                : '',
                        },
                        {
                            key: 'Thread Color',
                            value: $options.embroideryColor
                                ? $options.embroideryColor.threadColor
                                : '',
                        },
                        {
                            key: 'Color',
                            value: $options.embroideryColor
                                ? $options.embroideryColor.name
                                : '',
                        },
                        {
                            key: 'Embroidery Price',
                            value: '$' + $options.embroideryPrice.toFixed(2),
                        },
                    ],
                },
            ]

            //
        } else {
            lines = {
                quantity: Number(quantity),
                merchandiseId: product,
            }
            if (registryItemId) {
                lines['attributes'] = [
                    {
                        key: '_registry_item_id',
                        value: registryItemId,
                    },
                ]
            }
        }

        if (!cartId || cartId === '') {
            let cartCreateData = await createCart()
            cartId = cartCreateData.data.cartId

            console.log('new cart on PDP', cartId)

            let cartObj = {
                ...cartData.get(),
                cartId: cartId,
                checkoutUrl: cartCreateData.data.checkoutUrl,
            }

            cartData.set(cartObj)

            //

            addToCart(cartId, lines).then((addToCartData) => {
                if (!addToCartData?.body?.cartLinesAdd?.cart) {
                    hasCartQuantityError.set(true)
                    isCartOpen.set('is_cart_open', true)
                    return
                    // throw new Error('Failed to add item to cart')
                }
                let cartLines =
                    addToCartData.body?.cartLinesAdd?.cart?.lines?.edges
                let cartCost = addToCartData.body?.cartLinesAdd?.cart?.cost

                let cartObj = {
                    ...cartData.get(),
                    lines: cartLines,
                    cost: cartCost,
                }

                cartData.set(cartObj)

                isCartOpen.set('is_cart_open', true)
                clearOptions()

                if (sizes.length > 0) {
                    setCurrentSize({
                        size: '',
                        variantId: '',
                        sku: '',
                    })
                    setNoSizeError(false)
                }
                // else {
                //     setCurrentSize({
                //         size: 'nosize',
                //         variantId:
                //             initialVariant &&
                //             initialVariant[0] &&
                //             initialVariant[0].id,
                //         sku:
                //             initialVariant &&
                //             initialVariant[0] &&
                //             initialVariant[0].sku,
                //     })
                // }
                setQuantityDisabled(false)
                setIsLoading(false)
                setNoSizeError(false)

                chord.trackProductAdded({
                    cart: $cartData,
                    product: {
                        product: currentProduct,
                        quantity,
                        variantId: currentSize?.variantId,
                    },
                })

                dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
                dataLayer.push({
                    event: 'GA4_add_to_cart',
                    page: 'pdp',
                    ecommerce: {
                        currency: 'USD',
                        value: Number(currentPrice?.price),
                        items: [
                            {
                                item_id: String(variantId),
                                item_name: productTitle,
                                affiliation: 'Vercel',
                                item_brand: 'Monica + Andy',
                                item_category: currentColor ? currentColor : '',
                                item_category2: currentSize?.size,
                                item_variant: String(currentSize?.variantId),
                                price: Number(currentPrice?.price),
                                quantity: quantity,
                            },
                        ],
                    },
                })

                dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
                dataLayer.push({
                    event: 'dl_add_to_cart',
                    page: 'pdp',
                    ecommerce: {
                        currency: 'USD',
                        value: Number(currentPrice?.price),
                        items: [
                            {
                                item_id: String(variantId),
                                item_name: productTitle,
                                affiliation: 'Vercel',
                                item_brand: 'Monica + Andy',
                                item_category: currentColor ? currentColor : '',
                                item_category2: currentSize?.size,
                                item_variant: String(currentSize?.variantId),
                                price: Number(currentPrice?.price),
                                quantity: quantity,
                            },
                        ],
                    },
                })

                va.track('PDP Add To Cart', {
                    productName: productTitle,
                    productSku: currentSize?.sku,
                    productPrice: currentPrice?.price,
                    productQuantity: quantity,
                    productVariant: currentSize?.variantId,
                    productColor: currentColor ? currentColor : '',
                    productSize: currentSize?.size,
                })

                var atcItem = {
                    name: productTitle, // Replace with dynamic product name
                    price: currentPrice?.price, // Replace with dynamic product price
                    productID: currentProduct?.id
                        ? currentProduct?.id
                        : currentSize?.variantId, // Replace with dynamic product ID
                    variantID: currentSize?.variantId,
                    categories: currentColor ? currentColor : '', // Replace with dynamic product categories (optional)
                    imageURL:
                        currentImages && currentImages.length
                            ? currentImages[0]?.imageSrc
                            : initialVariant &&
                              initialVariant[0] &&
                              initialVariant[0].images
                            ? inititalVariant[0].images[0]
                            : null, // Replace with dynamic product image URL
                    URL: window?.location?.href, // Replace with dynamic product page URL
                    brand:
                        initialVariant && initialVariant[0]
                            ? initialVariant[0].vendor
                            : '', // Replace with dynamic product brand (optional)
                }

                const nostoItem = {
                    name: productTitle,
                    price_currency_code: 'USD',
                    product_id: currentProduct?.id
                        ? currentProduct?.id
                        : currentSize?.variantId,
                    quantity: quantity,
                    sku_id: currentSize?.variantId,
                    unit_price: currentPrice?.price,
                }

                console.log('cartLines', cartLines)

                const nostoCartLines = cartLines.map((line) => {
                    const productId = line.node.merchandise.product.id
                    const productIdNumber = productId.split('/').pop()
                    const skuId = line.node.merchandise.id
                    const skuIdNumber = skuId.split('/').pop()
                    return {
                        name: line.node.merchandise.product.title,
                        price_currency_code: 'USD',
                        product_id: productIdNumber,
                        quantity: line.node.quantity,
                        sku_id: skuIdNumber,
                        unit_price: Number(line.node.cost.totalAmount.amount),
                    }
                })

                nostojs((api) => {
                    api.defaultSession()
                        .setCart({
                            items: nostoCartLines,
                        })
                        .viewCart()
                        .update()
                        .then((response) => {
                            console.log('Nosto cart update response new cart:', response);
                            // Handle the response here
                            return response;
                        })
                        .catch((error) => {
                            console.error('Nosto cart update error:', error);
                        });
                })

                // console.log('TriplePixel', TriplePixel)

                // console.log('atcItem', atcItem)

                if (TriplePixel) {
                    TriplePixel('AddToCart', {
                        item: currentProduct?.id
                            ? currentProduct?.id
                            : currentSize?.variantId,
                        q: quantity,
                        v: currentSize?.variantId,
                        atcItem: atcItem,
                        productID: currentProduct?.id
                            ? currentProduct?.id
                            : currentSize?.variantId,
                    })
                }

                if (cje) {
                    let attributes = $cartData.attributes
                    if (!attributes) {
                        attributes = []
                    }
                    attributes.push({ key: 'cjevent', value: cje })
                    console.log(
                        'cje, attributes in add to cart no id',
                        cje,
                        attributes
                    )
                    updateCartAttributes(cartId, attributes)
                }

                var _learnq = _learnq || []
                _learnq.push(['track', 'Added to Cart', atcItem])

                let klaviyo = window.klaviyo || []
                console.log('klaviyo', klaviyo)
                klaviyo.push(['track', 'Added to Cart', atcItem])
                // if (geq) {
                //     geq.addToCart(atcItem)
                // }
            })
        } else {
            console.log('adding to existing cart', cartId, lines)

            addToCart(cartId, lines).then((addToCartData) => {
                if (!addToCartData?.body?.cartLinesAdd?.cart) {
                    hasCartQuantityError.set(true)
                    isCartOpen.set('is_cart_open', true)
                    return
                    // throw new Error('Failed to add item to cart')
                }
                let cartLines =
                    addToCartData.body?.cartLinesAdd?.cart?.lines?.edges
                let cartCost = addToCartData.body?.cartLinesAdd?.cart?.cost

                let cartObj = {
                    ...cartData.get(),
                    lines: cartLines,
                    cost: cartCost,
                }

                cartData.set(cartObj)
                setIsLoading(false)
                isCartOpen.set('is_cart_open', true)
                clearOptions()
                setNoSizeError(false)

                if (sizes.length > 0) {
                    setCurrentSize({
                        size: '',
                        variantId: '',
                        sku: '',
                    })
                }
                // else {
                //     setCurrentSize({
                //         size: 'nosize',
                //         variantId:
                //             initialVariant &&
                //             initialVariant[0] &&
                //             initialVariant[0].id,
                //         sku:
                //             initialVariant &&
                //             initialVariant[0] &&
                //             initialVariant[0].sku,
                //     })
                // }
                setQuantityDisabled(false)

                chord.trackProductAdded({
                    cart: $cartData,
                    product: {
                        product: currentProduct,
                        quantity,
                        variantId: currentSize?.variantId,
                    },
                })

                dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
                dataLayer.push({
                    event: 'GA4_add_to_cart',
                    page: 'pdp',
                    ecommerce: {
                        currency: 'USD',
                        value: Number(currentPrice?.price),
                        items: [
                            {
                                item_id: String(variantId),
                                item_name: productTitle,
                                affiliation: 'Vercel',
                                item_brand: 'Monica + Andy',
                                item_category: currentColor ? currentColor : '',
                                item_category2: currentSize?.size,
                                item_variant: String(currentSize?.variantId),
                                price: Number(currentPrice?.price),
                                quantity: quantity,
                            },
                        ],
                    },
                })

                dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
                dataLayer.push({
                    event: 'dl_add_to_cart',
                    page: 'pdp',
                    ecommerce: {
                        currency: 'USD',
                        value: Number(currentPrice?.price),
                        items: [
                            {
                                item_id: String(variantId),
                                item_name: productTitle,
                                affiliation: 'Vercel',
                                item_brand: 'Monica + Andy',
                                item_category: currentColor ? currentColor : '',
                                item_category2: currentSize?.size,
                                item_variant: String(currentSize?.variantId),
                                price: Number(currentPrice?.price),
                                quantity: quantity,
                            },
                        ],
                    },
                })

                va.track('PDP Add To Cart', {
                    productName: productTitle,
                    productSku: currentSize?.sku,
                    productPrice: currentPrice?.price,
                    productQuantity: quantity,
                    productVariant: currentSize?.variantId,
                    productColor: currentColor ? currentColor : '',
                    productSize: currentSize?.size,
                })

                let atcItem = {
                    name: productTitle, // Replace with dynamic product name
                    price: currentPrice?.price, // Replace with dynamic product price
                    productID: currentProduct?.id
                        ? currentProduct?.id
                        : currentSize?.variantId, // Replace with dynamic product ID
                    variantID: currentSize?.variantId,
                    categories: currentColor ? currentColor : '', // Replace with dynamic product categories (optional)
                    imageURL:
                        currentImages && currentImages.length
                            ? currentImages[0]?.imageSrc
                            : initialVariant &&
                              initialVariant[0] &&
                              initialVariant[0].images
                            ? inititalVariant[0].images[0]
                            : null, // Replace with dynamic product image URL
                    URL: window?.location?.href, // Replace with dynamic product page URL
                    brand:
                        initialVariant && initialVariant[0]
                            ? initialVariant[0].vendor
                            : '', // Replace with dynamic product brand (optional)
                }

                // console.log('atcItem')

                const nostoItem = {
                    name: productTitle,
                    price_currency_code: 'USD',
                    product_id: currentProduct?.id
                        ? currentProduct?.id
                        : currentSize?.variantId,
                    quantity: quantity,
                    sku_id: currentSize?.variantId,
                    unit_price: currentPrice?.price,
                }

                const nostoCartLines = cartLines.map((line) => {
                    console.log('line in nostoCartLines', line)
                    const productId = line.node.merchandise.product.id
                    const productIdNumber = productId.split('/').pop()
                    const skuId = line.node.merchandise.id
                    const skuIdNumber = skuId.split('/').pop()
                    return {
                        name: line.node.merchandise.product.title,
                        price_currency_code: 'USD',
                        product_id: productIdNumber,
                        quantity: line.node.quantity,
                        sku_id: skuIdNumber,
                        unit_price: Number(line.node.cost.totalAmount.amount),
                    }
                })

                console.log('nostoCartLines', nostoCartLines)

                nostojs((api) => {
                    api.defaultSession()
                        .setCart({
                            items: nostoCartLines,
                        })
                        .viewCart()
                        .update()
                        .then((response) => {
                            console.log('Nosto cart update response exisiting cart:', response);
                            // Handle the response here
                            return response;
                        })
                        .catch((error) => {
                            console.error('Nosto cart update error:', error);
                        });
                })

                if (cje) {
                    let attributes = $cartData.attributes
                    if (!attributes) {
                        attributes = []
                    }
                    attributes.push({ key: 'cjevent', value: cje })
                    console.log(
                        'cje, attributes in add to cart',
                        cje,
                        attributes
                    )
                    updateCartAttributes(cartId, attributes)
                }

                if (TriplePixel) {
                    TriplePixel('AddToCart', {
                        item: currentProduct?.id
                            ? currentProduct?.id
                            : currentSize?.variantId,
                        q: quantity,
                        v: currentSize?.variantId,
                        atcItem: atcItem,
                    })
                }

                var _learnq = _learnq || []
                _learnq.push(['track', 'Added to Cart', atcItem])

                let klaviyo = window.klaviyo || []
                console.log('klaviyo', klaviyo)
                klaviyo.push(['track', 'Added to Cart', atcItem])

                // if (geq) {
                //     geq.addToCart(atcItem)
                // }
            })
        }
    }

    const handleLightbox = (index) => {
        if (windowWidth && windowWidth < 768) {
            return
        }
        setOpen(true)
        setSlideIndex(index)
    }

    const nullFunction = () => {}

    const handleAddToBabyList = (title, image) => {
        bl.addToRegistry({
            images: image,
            price: currentPrice.price,
            title: title,
            url: productUrl,
        })
    }
    // const nullFunction = () => {}

    //

    useEffect(() => {
        const scriptTag = document.createElement('script')
        scriptTag.src =
            'https://apps.bazaarvoice.com/deployments/monicaandandy/main_site/production/en_US/bv.js'
        document.body.appendChild(scriptTag)

        setTimeout(() => {
            const bvReviewsText = document.querySelectorAll(
                '.bv_numReviews_text'
            )

            if (bvReviewsText.length) {
                if (bvReviewsText[0].innerHTML.indexOf('(0)') > -1) {
                    document
                        .querySelector('.bv_main_container')
                        .classList.add('hidden')
                }
            }
        }, 1000)
    }, [])

    //

    //

    const handleRestockSubmit = (e) => {
        e.preventDefault()
        const form = e.currentTarget
        const formData = new FormData(e.currentTarget)

        let data = {}

        let signupEmail

        for (let [key, value] of formData.entries()) {
            data[key] = value
        }
        //

        if (data.email) {
            signupEmail = data.email

            if (!IsEmail(signupEmail)) {
                alert('Please enter a valid email address')
                return
            }
        }

        if (signupEmail && signupEmail !== '' && IsEmail(signupEmail)) {
            const options = {
                method: 'POST',
                headers: {
                    revision: '2024-02-15',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    data: {
                        type: 'subscription',
                        attributes: {
                            custom_source: 'Restock form on PDP',
                            profile: {
                                data: {
                                    type: 'profile',
                                    id: '01GDDKASAP8TKDDA2GRZDSVP4H',
                                    attributes: {
                                        email: signupEmail,
                                        properties: data,
                                    },
                                    meta: {
                                        patch_properties: {
                                            append: { newKey: 'New Value' },
                                            unappend: { newKey: 'New Value' },
                                            unset: 'skus',
                                        },
                                    },
                                },
                            },
                        },
                        relationships: {
                            list: { data: { type: 'list', id: 'Ta9ENK' } },
                        },
                    },
                }),
            }

            fetch(
                'https://a.klaviyo.com/client/subscriptions/?company_id=NccvvG',
                options
            )
                .then((response) => {
                    //
                    if (response.ok) {
                        const restockForm = document.getElementById(
                            'restock-notify-form'
                        )
                        restockForm.reset()
                        restockForm.classList.add('hidden')
                        const restockSuccess =
                            document.getElementById('restock-success')
                        restockSuccess.classList.remove('hidden')
                        setTimeout(() => {
                            restockSuccess.classList.add('hidden')
                            restockForm.classList.remove('hidden')
                            setShowRestock(false)
                        }, 5000)
                    } else {
                        throw new Error('Something went wrong')
                    }
                })

                .catch((err) => console.error(err))
        } else {
            alert('Please enter a valid email address')
        }

        function IsEmail(email) {
            var regex =
                /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
            if (!regex.test(email)) {
                return false
            } else {
                return true
            }
        }
    }

    // console.log('isDoorbuster', isDoorbuster)

    return (
        <div className="product-wrap relative">
            {isLoading ? <Loader /> : null}
            <div className="product-outer main-product wrap-xl mx-auto mt-6 md:px-6 2xl:px-0 relative">
                <div className="product-inner flex justify-center flex-wrap lg:flex-nowrap lg:gap-6 xl:gap-12 mx-auto px-4 xl:px-0 mb-12">
                    {/* {isDoorbuster ? (
                        <div className='doorbuster-countdown bg-[#E24B52] py-1 flex-row w-full items-center justify-center gap-1 flex lg:hidden'>
                            <span className='text-xs text-white'>
                                Deal ends in:
                            </span>
                            <Countdown
                                showLabels={false}
                                showShortLabels={true}
                                smallText={true}
                            />
                        </div>
                    ) : null} */}
                    <div className="product-images-outer w-full lg:w-5/12">
                        <div className="product-images-inner flex gap-4 overflow-x-auto">
                            <div className="image-grid relative flex items-center">
                                <ul
                                    id="image-grid"
                                    className="images-nav nostyle md:grid md:grid-cols-2 gap-2 flex items-center overflow-x-scroll md:overflow-x-hidden relative"
                                >
                                    {currentImages &&
                                        currentImages.map((n, i) => {
                                            //
                                            return (
                                                <li
                                                    key={n.id}
                                                    data-index={i}
                                                    data-color={n.initial_color}
                                                    className={`nav-image relative flex items-center h-auto w-[95vw] lg:w-full ${
                                                        i === 0
                                                            ? 'md:w-full md:col-span-2'
                                                            : 'md:width-unset'
                                                    }`}
                                                    title={n.initial_color}
                                                >
                                                    {i !== 0 ? (
                                                        <div
                                                            className="caret-left md:hidden absolute left-3 text-flint cursor-pointer"
                                                            onClick={(e) =>
                                                                handleImageNavigation(
                                                                    e,
                                                                    'left',
                                                                    i
                                                                )
                                                            }
                                                        >
                                                            <AngleLeft width="w-[12px]" />
                                                        </div>
                                                    ) : null}

                                                    <img
                                                        className="md:cursor-pointer"
                                                        src={n.imageSrc}
                                                        alt={n.initial_color}
                                                        onClick={() =>
                                                            handleLightbox(i)
                                                        }
                                                        fetchPriority="high"
                                                    />

                                                    {i <
                                                    currentImages.length - 1 ? (
                                                        <div
                                                            className="caret-right md:hidden right-[21px] absolute text-flint cursor-pointer"
                                                            onClick={(e) =>
                                                                handleImageNavigation(
                                                                    e,
                                                                    'right',
                                                                    i
                                                                )
                                                            }
                                                        >
                                                            <AngleRight width="w-[12px]" />
                                                        </div>
                                                    ) : null}
                                                </li>
                                            )
                                        })}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="product-content-outer w-full lg:w-7/12 lg:ml-6">
                        <div className="product-content-inner">
                            <div
                                id="pixel-to-watch"
                                className="h-[1px] w-[1px] bg-transparent text-transparent"
                            ></div>
                            <div className="product-header pb-3 border-b border-slate">
                                <div className="product-above-title flex w-full gap-2">
                                    {noGots || nogots ? null : (
                                        <div className="organic-tag">
                                            <OrganicTag />
                                        </div>
                                    )}
                                    {currentProduct && currentProduct.tags ? (
                                        <div className="product-flags my-2 flex gap-2 flex-wrap ml-auto">
                                            <Flags
                                                currentProduct={currentProduct}
                                                currentProductTags={
                                                    currentProduct?.tags
                                                }
                                                tagObject={tagObject}
                                            />
                                        </div>
                                    ) : null}

                                    {/* <div className="product-offers w-1/2 text-right my-2">
                                        {currentProduct ? (
                                            <ProductOffers
                                                currentProduct={currentProduct}
                                            />
                                        ) : null}
                                    </div> */}
                                </div>
                                <div className="product-title-price flex w-full relative">
                                    <h1 className="product-title text-2xl w-1/2 leading-tight pr-3 lg:pr-0">
                                        {productTitle &&
                                            productTitle
                                                .split('_')[0]
                                                .replace('[hidden]', '')
                                                .replace('DOORBUSTER - ', '')}
                                    </h1>
                                    <Price
                                        product={currentProduct}
                                        matchingVariants={currentVariants}
                                        variantIdOnLoad={variantIdOnLoad}
                                        priceType="product"
                                    />
                                </div>

                                {}
                                {!hideReviews ? (
                                    <a
                                        href="#product-reviews"
                                        className="cursor-pointer relative"
                                    >
                                        <div
                                            data-bv-show="rating_summary"
                                            data-bv-product-id={
                                                parentProductId
                                                    ? parentProductId
                                                    : hiddenProduct &&
                                                      hiddenProduct[0]
                                                    ? hiddenProduct[0].id
                                                    : mainProduct &&
                                                      mainProduct[0]
                                                    ? mainProduct[0].id
                                                    : currentProduct &&
                                                      currentProduct[0]
                                                    ? currentProduct[0].id
                                                    : null
                                            }
                                        ></div>
                                    </a>
                                ) : null}
                            </div>

                            <Affirm product={currentProduct} />

                            <div className="product-options">
                                {colors?.basicColors?.length ||
                                colors?.limitedColors?.length ||
                                colors?.trunkSaleColors?.length ||
                                colors?.marketplaceColors?.length ? (
                                    <div className="product-swatches pb-6 border-b border-y-slate">
                                        <div className="current-color-text text-xs mb-1 flex items-center">
                                            <h2 className="text-sm">
                                                Choose A Color
                                            </h2>
                                            <span className="current-color-text-text block ml-auto">
                                                <span className="font-semibold">
                                                    Selected:
                                                </span>
                                                &nbsp;
                                                {currentColor && currentColor
                                                    ? currentColor
                                                    : ''}
                                            </span>
                                        </div>

                                        {colors && colors.basicColors ? (
                                            <div className="color-section mt-3 overflow-x-hidden lg:overflow-x-visible">
                                                <div className="color-text text-xs -500 mb-1">
                                                    Basics:{' '}
                                                </div>
                                                <ul className="swatch-list pattern-list nostyle flex flex-wrap gap-1">
                                                    {colors.basicColors.map(
                                                        (s, i) => {
                                                            //
                                                            const swatchSlug =
                                                                slugify(s.color)
                                                            return (
                                                                <li
                                                                    key={
                                                                        swatchSlug
                                                                    }
                                                                    className={`swatch swatch-item w-10 hover:cursor-pointer ${
                                                                        currentColor &&
                                                                        currentColor ===
                                                                            s.color.replace(
                                                                                /\//g,
                                                                                ' '
                                                                            )
                                                                            ? 'swatch-selected'
                                                                            : ''
                                                                    }`}
                                                                    data-swatch-index={
                                                                        i
                                                                    }
                                                                    data-swatch-color={
                                                                        swatchSlug
                                                                    }
                                                                    aria-label={
                                                                        s.color
                                                                    }
                                                                    data-balloon-pos={`${
                                                                        windowWidth &&
                                                                        windowWidth <
                                                                            768 &&
                                                                        i === 0
                                                                            ? 'up-left'
                                                                            : 'up'
                                                                    }`}
                                                                    onClick={() =>
                                                                        handleSwatchClick(
                                                                            swatchSlug,
                                                                            s.color,
                                                                            i
                                                                        )
                                                                    }
                                                                >
                                                                    <div className="swatch-image">
                                                                        <img
                                                                            className="rounded-full border border-oat hover:border-ocean hover:border-2"
                                                                            src={`${FILES_URL}maswatch-${swatchSlug}-96.png`}
                                                                            alt={
                                                                                s.color
                                                                            }
                                                                        />
                                                                    </div>
                                                                </li>
                                                            )
                                                        }
                                                    )}
                                                </ul>
                                            </div>
                                        ) : null}
                                        {colors && colors.limitedColors ? (
                                            <div className="color-section mt-3 overflow-x-hidden lg:overflow-x-visible">
                                                <div className="color-text text-xs -500 mb-1">
                                                    Limited Edition:{' '}
                                                </div>
                                                <ul className="swatch-list pattern-list nostyle flex flex-wrap gap-1">
                                                    {colors.limitedColors.map(
                                                        (s, i) => {
                                                            const swatchSlug =
                                                                slugify(s.color)
                                                            return (
                                                                <li
                                                                    key={
                                                                        swatchSlug
                                                                    }
                                                                    className={`swatch swatch-item w-10 hover:cursor-pointer ${
                                                                        currentColor &&
                                                                        currentColor ===
                                                                            s.color.replace(
                                                                                /\//g,
                                                                                ' '
                                                                            )
                                                                            ? 'swatch-selected'
                                                                            : ''
                                                                    }`}
                                                                    data-swatch-index={
                                                                        i
                                                                    }
                                                                    data-swatch-color={
                                                                        swatchSlug
                                                                    }
                                                                    aria-label={
                                                                        s.color
                                                                    }
                                                                    data-balloon-pos={`${
                                                                        windowWidth &&
                                                                        windowWidth <
                                                                            768 &&
                                                                        i === 0
                                                                            ? 'up-left'
                                                                            : 'up'
                                                                    }`}
                                                                    onClick={() =>
                                                                        handleSwatchClick(
                                                                            swatchSlug,
                                                                            s.color,
                                                                            i
                                                                        )
                                                                    }
                                                                >
                                                                    <div className="swatch-image">
                                                                        <img
                                                                            className="rounded-full border border-oat hover:border-ocean hover:border-2"
                                                                            src={`${FILES_URL}maswatch-${swatchSlug}-96.png`}
                                                                            alt={
                                                                                s.color
                                                                            }
                                                                        />
                                                                    </div>
                                                                </li>
                                                            )
                                                        }
                                                    )}
                                                </ul>
                                            </div>
                                        ) : null}
                                        {colors && colors.trunkSaleColors ? (
                                            <div className="color-section mt-3 overflow-x-hidden lg:overflow-x-visible">
                                                <div className="color-text text-xs -500 mb-1">
                                                    Sale:{' '}
                                                </div>
                                                <ul className="swatch-list pattern-list nostyle flex flex-wrap gap-1">
                                                    {colors.trunkSaleColors.map(
                                                        (s, i) => {
                                                            const swatchSlug =
                                                                slugify(s.color)
                                                            return (
                                                                <li
                                                                    key={
                                                                        swatchSlug
                                                                    }
                                                                    className={`swatch swatch-item w-10 rounded-full hover:cursor-pointer  ${
                                                                        currentColor &&
                                                                        currentColor ===
                                                                            s.color.replace(
                                                                                /\//g,
                                                                                ' '
                                                                            )
                                                                            ? 'swatch-selected'
                                                                            : ''
                                                                    }`}
                                                                    data-swatch-index={
                                                                        i
                                                                    }
                                                                    data-swatch-color={
                                                                        swatchSlug
                                                                    }
                                                                    aria-label={
                                                                        s.color
                                                                    }
                                                                    data-balloon-pos={`${
                                                                        windowWidth &&
                                                                        windowWidth <
                                                                            768 &&
                                                                        i === 0
                                                                            ? 'up-left'
                                                                            : 'up'
                                                                    }`}
                                                                    onClick={() =>
                                                                        handleSwatchClick(
                                                                            swatchSlug,
                                                                            s.color,
                                                                            i
                                                                        )
                                                                    }
                                                                >
                                                                    <div className="swatch-image">
                                                                        <img
                                                                            className="rounded-full border border-oat hover:border-ocean hover:border-2"
                                                                            src={`${FILES_URL}maswatch-${swatchSlug}-96.png`}
                                                                            alt={
                                                                                s.color
                                                                            }
                                                                        />
                                                                    </div>
                                                                </li>
                                                            )
                                                        }
                                                    )}
                                                </ul>
                                            </div>
                                        ) : null}
                                        {colors && colors.marketplaceColors ? (
                                            <div className="color-section mt-3">
                                                <div className="color-text text-xs -500 mb-1">
                                                    Colors:{' '}
                                                </div>
                                                <ul className="swatch-list pattern-list nostyle flex flex-wrap gap-1">
                                                    {colors.marketplaceColors.map(
                                                        (s, i) => {
                                                            const swatchSlug =
                                                                slugify(s.color)
                                                            return (
                                                                <li
                                                                    key={
                                                                        swatchSlug
                                                                    }
                                                                    className={`swatch swatch-item w-10 rounded-full hover:cursor-pointer  ${
                                                                        currentColor &&
                                                                        currentColor ===
                                                                            s.color.replace(
                                                                                /\//g,
                                                                                ' '
                                                                            )
                                                                            ? 'swatch-selected'
                                                                            : ''
                                                                    }`}
                                                                    data-swatch-index={
                                                                        i
                                                                    }
                                                                    data-swatch-color={
                                                                        swatchSlug
                                                                    }
                                                                    aria-label={
                                                                        s.color
                                                                    }
                                                                    data-balloon-pos={`${
                                                                        windowWidth &&
                                                                        windowWidth <
                                                                            768 &&
                                                                        i === 0
                                                                            ? 'up-left'
                                                                            : 'up'
                                                                    }`}
                                                                    onClick={() =>
                                                                        handleSwatchClick(
                                                                            swatchSlug,
                                                                            s.color,
                                                                            i
                                                                        )
                                                                    }
                                                                >
                                                                    <div className="swatch-image">
                                                                        <img
                                                                            className="rounded-full border border-oat hover:border-ocean hover:border-2"
                                                                            src={`${FILES_URL}maswatch-${swatchSlug}-96.png`}
                                                                            alt={
                                                                                s.color
                                                                            }
                                                                        />
                                                                    </div>
                                                                </li>
                                                            )
                                                        }
                                                    )}
                                                </ul>
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null}
                                {/* {} */}
                                {sizes && sizes.length ? (
                                    <div
                                        id="product-sizes"
                                        className={`product-sizes pt-3 pb-3 border-t border-slate ${
                                            noSizeError
                                                ? 'outline outline-4 outline-red-400 outline-offset-8 pb-0'
                                                : ''
                                        }`}
                                    >
                                        <div className="size-text text-xs flex items-center mb-2">
                                            <h2 className="text-sm">
                                                Choose A Size
                                            </h2>{' '}
                                            <span className="current-size-text block ml-auto">
                                                <span className="font-semibold">
                                                    Selected:
                                                </span>{' '}
                                                {currentSize.size &&
                                                currentSize.size !== 'nosize'
                                                    ? currentSize.size
                                                    : '(none)'}
                                            </span>
                                        </div>
                                        {isRestock ? (
                                            <p className="text-xs text-flint mt-1 mb-2">
                                                Click on an out-of-stock size to
                                                get notified when it is back in
                                                stock.
                                            </p>
                                        ) : null}
                                        <ul className="size-list nostyle grid grid-cols-4 lg:grid-cols-8 gap-2">
                                            {sizes.map((s, i) => {
                                                {
                                                    // console.log('s', s)
                                                }
                                                if (
                                                    s.initial_size &&
                                                    s.initial_size !== ''
                                                ) {
                                                    return (
                                                        <li
                                                            key={s.initial_size}
                                                            className={`size h-[36px] border border-oat rounded-sm flex items-center justify-center px-2 text-sm hover:cursor-pointer hover:bg-flint hover:text-white  ${
                                                                currentSize.size &&
                                                                currentSize.size ===
                                                                    s.initial_size
                                                                    ? 'size-selected bg-ash text-white'
                                                                    : 'bg-white'
                                                            } ${
                                                                s.inventory_quantity ===
                                                                0
                                                                    ? `${
                                                                          isRestock
                                                                              ? 'size-out-of-stock'
                                                                              : 'size-out-of-stock cursor-not-allowed pointer-events-none'
                                                                      }`
                                                                    : ''
                                                            }`}
                                                            onClick={() =>
                                                                handleSizeClick(
                                                                    s.initial_size,
                                                                    s.variantId,
                                                                    i,
                                                                    s.sku,
                                                                    s.inventory_quantity
                                                                )
                                                            }
                                                            data-variant-id={
                                                                s.variantId
                                                            }
                                                            data-size={
                                                                s.initial_size
                                                            }
                                                        >
                                                            <span className="size-label text-xs">
                                                                {s.initial_size}
                                                            </span>
                                                        </li>
                                                    )
                                                }
                                                return null
                                            })}
                                        </ul>
                                        <div className="size-guide-wrap ml-auto mt-2">
                                            <SizeGuide />
                                        </div>
                                        {noSizeError ? (
                                            <p className="text-xs text-red-400 mt-2">
                                                Please select a size
                                            </p>
                                        ) : null}
                                        {showRestock ? (
                                            <div className="restock-notify-wrap mt-2 p-3 border border-carrot">
                                                <form
                                                    id="restock-notify-form"
                                                    className="restock-notify-form"
                                                    onSubmit={
                                                        handleRestockSubmit
                                                    }
                                                >
                                                    <input
                                                        type="hidden"
                                                        name="restock_variant_id"
                                                        value={
                                                            currentSize.variantId
                                                        }
                                                    />
                                                    <input
                                                        type="hidden"
                                                        name="restock_size"
                                                        value={currentSize.size}
                                                    />
                                                    <input
                                                        type="hidden"
                                                        name="restock_sku"
                                                        value={currentSize.sku}
                                                    />
                                                    <input
                                                        type="hidden"
                                                        name="restock_title"
                                                        value={
                                                            currentProduct &&
                                                            currentProduct.title
                                                                ? currentProduct.title
                                                                : productTitle
                                                        }
                                                    />
                                                    <label
                                                        htmlFor="restock-notify-email"
                                                        className="text-xs"
                                                    >
                                                        Notify me when this size
                                                        is back in stock:
                                                        <input
                                                            type="email"
                                                            id="restock-notify-email"
                                                            name="email"
                                                            placeholder="Email address"
                                                            className="w-full mt-1 bg-[#f8f8f8] border border-oat h-12 px-2 text-lg"
                                                            required
                                                        />
                                                    </label>
                                                    <button
                                                        type="submit"
                                                        className="button-secondary button-restock-notify w-full mt-2"
                                                    >
                                                        Notify Me
                                                    </button>
                                                </form>
                                                <p
                                                    id="restock-success"
                                                    className="hidden text-sm text-pine my-2"
                                                >
                                                    You've been added to the
                                                    restock list. We'll email
                                                    you when this product is
                                                    back in stock!
                                                </p>
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null}

                                <div className="product-actions product-actions-outer pt-3 pb-3 product-actions-bottom">
                                    <div className="product-actions-inner flex flex-wrap lg:flex-nowrap items-center gap-x-4">
                                        <div className="product-add-to-cart w-full max-w-[400px] relative lg:top-[15px]">
                                            <Fragment>
                                                {!currentSize.size ? (
                                                    <p className="block mobile-size-error text-xs mb-0 text-gray-500 w-full md:hidden">
                                                        Please select a size
                                                    </p>
                                                ) : null}
                                                <input
                                                    type="hidden"
                                                    min="1"
                                                    name="quantity"
                                                    value={quantity}
                                                />
                                                <input
                                                    type="hidden"
                                                    name="id"
                                                    id="variant-id"
                                                    value={
                                                        currentSize.variantId
                                                            ? currentSize.variantId
                                                            : variants.length >
                                                              0
                                                            ? variants[0].id
                                                            : ''
                                                    }
                                                />
                                            </Fragment>
                                            <button
                                                type={
                                                    !currentSize.size
                                                        ? null
                                                        : 'submit'
                                                }
                                                id="pdp-add-to-cart"
                                                className={`large-button button-atc w-full !h-12 flex-grow mb-2 ${
                                                    !currentSize.size
                                                        ? 'noclick cursor-not-allowed hover:opacity-90'
                                                        : 'hover:bg-ash opacity-100'
                                                }`}
                                                // data-balloon-blunt
                                                data-balloon-pos="up"
                                                // aria-label={
                                                //     !currentSize.size
                                                //         ? 'Please select a size'
                                                //         : null
                                                // }
                                                onClick={(e) =>
                                                    handleAddToCart(e)
                                                }
                                            >
                                                {!currentSize.size
                                                    ? 'Please select a size'
                                                    : 'Add To Cart'}
                                            </button>
                                        </div>

                                        <div
                                            className={`product-quantity flex flex-col  ${
                                                quantityDisabled
                                                    ? 'opacity-30 pointer-events-none'
                                                    : ''
                                            }`}
                                        >
                                            <div className="product-quantity-label text-xs mb-2">
                                                Quantity:
                                            </div>
                                            <div className="product-quantity-wrap flex items-center gap-0 h-[42px] lg:mr-3 ">
                                                <button
                                                    className={`quantity-decrement bg-slate text-lg aspect-square w-8 h-12 ${
                                                        quantity === 1
                                                            ? 'quantity-disabled'
                                                            : ''
                                                    }`}
                                                    onClick={
                                                        handleQuantityDecrement
                                                    }
                                                >
                                                    <span className="minus">
                                                        –
                                                    </span>
                                                </button>
                                                <input
                                                    className="quantity-input text-center w-12 text-lg flex-1 border border-slate h-12"
                                                    type="number"
                                                    name="quantity"
                                                    value={quantity}
                                                    onKeyPress={(e) => {
                                                        if (
                                                            e.target.value
                                                                .length > 2
                                                        )
                                                            e.preventDefault()
                                                    }}
                                                    onChange={
                                                        handleQuantityChange
                                                    }
                                                    max="99"
                                                />
                                                <button
                                                    className="quantity-increment aspect-square bg-slate text-lg w-8 h-12"
                                                    onClick={
                                                        handleQuantityIncrement
                                                    }
                                                >
                                                    <span className="plus">
                                                        +
                                                    </span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="product-add-to-registry mt-5 flex-1">
                                            <div className="registry-actions flex items-center">
                                                <button
                                                    className={`large-button button-registry flex-1 w-full registry-trigger !text-xs !h-12 relative top-[1px] ${
                                                        !currentSize.size
                                                            ? 'disabled noclick opacity-80'
                                                            : 'opacity-100 hover:bg-oat'
                                                    }`}
                                                    data-variant-id={
                                                        currentSize.variantId
                                                    }
                                                    data-balloon-blunt
                                                    data-balloon-pos="up"
                                                    aria-label={
                                                        !currentSize.size
                                                            ? 'Please select a size'
                                                            : null
                                                    }
                                                    disabled={
                                                        !currentSize.size
                                                            ? true
                                                            : false
                                                    }
                                                    onClick={() => {
                                                        if (!currentSize.size) {
                                                            nullFunction()
                                                        } else {
                                                            handleAddToBabyList(
                                                                productTitle
                                                                    .split(
                                                                        '_'
                                                                    )[0]
                                                                    .replace(
                                                                        '[hidden]',
                                                                        ''
                                                                    ),
                                                                mainImage
                                                                    ? mainImage.src
                                                                    : null,
                                                                currentSize.variantId,
                                                                quantity
                                                            )
                                                        }
                                                    }}
                                                >
                                                    <span className="flex items-center justify-center gap-2">
                                                        <Heart width="w-[16px]" />
                                                        <span className="text-xs">
                                                            Add To Babylist
                                                            Registry
                                                        </span>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {embroidery && (
                                    <Embroidery
                                        productOptions={productOptions}
                                        setProductOptions={setProductOptions}
                                        handleOptions={handleOptions}
                                        clearOptions={clearOptions}
                                        productHandle={slug}
                                        handleAddToCart={handleAddToCart}
                                        currentSize={currentSize}
                                    />
                                )}
                            </div>

                            {quantityDisabled ? (
                                <p className="quantity-disabled-message text-xs text-flint font-normal">
                                    Quantity is limited to 1 for embroidered
                                    products. If you want multiple embroidered
                                    products, you will need to add them to your
                                    cart one at a time. Questions about
                                    embroidery? Email{' '}
                                    <a
                                        href="mailto:storks@monicaandandy.com"
                                        className="underline"
                                    >
                                        storks@monicaandandy.com
                                    </a>
                                    .
                                </p>
                            ) : null}

                            <div className="product-description">
                                {/* {mainProduct &&
                                mainProduct[0].vendor === 'Monica + Andy' &&
                                mainProduct[0].product_type !== 'Swimwear' &&
                                mainProduct[0].handle.indexOf('sun-hat') ===
                                    -1 ? (
                                    <div className="gots-certified-logo float-right w-28">
                                        <img
                                            src="https://cdn.shopify.com/s/files/1/2338/2917/files/GOTS-certified-logo.png?v=1637948846"
                                            alt="GOTS Certified Logo"
                                            className="gots-certified-logo-img"
                                        />
                                    </div>
                                ) : null} */}

                                {productDescriptionText && (
                                    <div className="product-desc-accordion my-3 border-b border-slate">
                                        <PDPAccordion
                                            desc={productDescriptionText}
                                            valueProps={valuePropsObj}
                                            nogots={nogots}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="value-props">
                                <div className="value-props-image">
                                    <div className="value-props-image-desktop hidden lg:block">
                                        <a href="/pages/about-us">
                                            <img
                                                src="https://cdn.shopify.com/s/files/1/2338/2917/files/MA_Promise_-_PDP_Banner_Desktop.webp?v=1725049176"
                                                alt="Monica + Andy Promise"
                                            />
                                        </a>
                                    </div>
                                    <div className="value-props-image-desktop block lg:hidden">
                                        <a href="/pages/about-us">
                                            <img
                                                src="https://cdn.shopify.com/s/files/1/2338/2917/files/MA_Promise_-_PDP_Banner_Mobile.webp?v=1725049176"
                                                alt="Monica + Andy Promise"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                index={slideIndex}
                slides={slides}
                plugins={[Zoom]}
                zoom={{
                    maxZoomPixelRatio: 5,
                }}
            />
            <div className="below-product-outer">
                <div className="below-product-inner wrap-xl mx-auto px-4 2xl:px-0">
                    {currentProduct && currentProduct.id ? (
                        <Fragment>
                            <NostoRecommendations
                                productId={currentProduct?.id}
                                slug={slug}
                                placements={['productpage-you-may-also-like', 'productpage-others-from-collection']}
                            />
                            {/* <Recommended
                                productIds={[currentProduct?.id]}
                                title="Frequently Bought Together"
                                type="carousel"
                            />
                            <Recommended
                                productIds={[currentProduct?.id]}
                                title="Best Sellers"
                                type="carousel"
                            /> */}

                        </Fragment>
                    ) : null}

                    {!hideReviews ? (
                        <div
                            id="product-reviews"
                            className="product-reviews-outer"
                        >
                            <div className="product-reviews-inner">
                                {console.log(
                                    'parentProductId',
                                    parentProductId
                                )}
                                {slug &&
                                slug.indexOf('disney-princess-double-ruffle') >
                                    -1 ? (
                                    <div
                                        data-bv-show="reviews"
                                        data-bv-product-id="6933496070206"
                                    ></div>
                                ) : (
                                    <div
                                        data-bv-show="reviews"
                                        data-bv-product-id={
                                            parentProductId
                                                ? parentProductId
                                                : hiddenProduct &&
                                                  hiddenProduct[0]
                                                ? hiddenProduct[0].id
                                                : mainProduct && mainProduct[0]
                                                ? mainProduct[0].id
                                                : currentProduct &&
                                                  currentProduct[0]
                                                ? currentProduct[0].id
                                                : null
                                        }
                                    ></div>
                                )}
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>

            <ProductSchema
                mainProduct={mainProduct}
                product={currentProduct}
                productTitle={productTitle}
                matchingVariants={currentVariants}
                variantIdOnLoad={variantIdOnLoad}
                productDescription={productDescription}
                sku={currentSize.sku}
                mainImage={mainImage}
                currentPrice={currentPrice}
            />

            <StickyAddToCart
                handleAddToCart={handleAddToCart}
                showStickyATC={showStickyATC}
                currentSize={currentSize}
            />
        </div>
    )
}

export default Product
